// Generische Alltags-/Finanzrechner: reine Funktionen, keine UI.
const num = (v) => (Number(v) || 0);
function round(v, n = 2) {
  if (!isFinite(v)) return 0;
  const f = 10 ** n;
  return Math.round(v * f) / f;
}

// --- Prozent ---
export const prozentVonWert = (prozent, grundwert) => round(num(grundwert) * num(prozent) / 100);
export const anteilProzent = (teil, grundwert) => (num(grundwert) === 0 ? 0 : round(num(teil) / num(grundwert) * 100));
export const veraenderungProzent = (alt, neu) => (num(alt) === 0 ? 0 : round((num(neu) - num(alt)) / num(alt) * 100));

// --- Mehrwertsteuer / USt ---
export function mwst(betrag, satz, richtung = "nettoZuBrutto") {
  const b = num(betrag);
  const s = num(satz);
  if (richtung === "bruttoZuNetto") {
    const netto = b / (1 + s / 100);
    return { netto: round(netto), steuer: round(b - netto), brutto: round(b) };
  }
  const steuer = b * s / 100;
  return { netto: round(b), steuer: round(steuer), brutto: round(b + steuer) };
}

// --- Dreisatz ---
export function dreisatz(a, b, c, modus = "proportional") {
  const A = num(a), B = num(b), C = num(c);
  if (A === 0) return 0;
  return modus === "antiproportional" ? round(A * B / C, 4) : round(B * C / A, 4);
}

// --- Zinseszins (Sparen) ---
export function zinseszins(startkapital, zinssatz, jahre, sparrateJaehrlich = 0) {
  const K = num(startkapital), i = num(zinssatz) / 100, n = num(jahre), R = num(sparrateJaehrlich);
  const wachstum = Math.pow(1 + i, n);
  const ausStart = K * wachstum;
  const ausSparplan = i === 0 ? R * n : R * ((wachstum - 1) / i);
  const endkapital = ausStart + ausSparplan;
  const eingezahlt = K + R * n;
  return { endkapital: round(endkapital), eingezahlt: round(eingezahlt), zinsertrag: round(endkapital - eingezahlt) };
}

// --- Stundenlohn ---
const WOCHEN_PRO_MONAT = 4.333;
export function stundenlohn(wert, stundenProWoche, richtung = "gehaltZuStundenlohn") {
  const w = num(wert), std = num(stundenProWoche);
  const stdProMonat = std * WOCHEN_PRO_MONAT;
  if (richtung === "stundenlohnZuGehalt") {
    return { stundenlohn: round(w), monat: round(w * stdProMonat), jahr: round(w * stdProMonat * 12) };
  }
  const sl = stdProMonat === 0 ? 0 : w / stdProMonat;
  return { stundenlohn: round(sl), monat: round(w), jahr: round(w * 12) };
}

// --- Rabatt ---
export function rabatt(preis, wert, modus = "prozent") {
  const p = num(preis), w = num(wert);
  if (modus === "endpreis") {
    // wert = bekannter Endpreis -> Rabatt in %
    const ersparnis = p - w;
    return { endpreis: round(w), ersparnis: round(ersparnis), prozent: p === 0 ? 0 : round(ersparnis / p * 100) };
  }
  // wert = Rabatt in % -> Endpreis
  const ersparnis = p * w / 100;
  return { endpreis: round(p - ersparnis), ersparnis: round(ersparnis), prozent: round(w) };
}

// --- Arbeitszeit (Start/Ende als "HH:MM", Pause in Minuten) ---
function zeitZuMin(t) {
  if (!t) return 0;
  const [h, m] = String(t).split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
}
export function arbeitszeit(start, ende, pauseMin = 0) {
  let diff = zeitZuMin(ende) - zeitZuMin(start);
  if (diff < 0) diff += 24 * 60; // über Mitternacht
  const netto = Math.max(0, diff - num(pauseMin));
  return { minuten: netto, stunden: Math.floor(netto / 60), rest: netto % 60, dezimal: round(netto / 60) };
}

// --- Fläche (Rechteck) ---
export function flaeche(laenge, breite) {
  return { flaeche: round(num(laenge) * num(breite)), umfang: round(2 * (num(laenge) + num(breite))) };
}

// --- Spritkosten ---
export function spritkosten(strecke, verbrauch, preis, personen = 1) {
  const liter = num(strecke) / 100 * num(verbrauch);
  const kosten = liter * num(preis);
  const p = Math.max(1, Math.round(num(personen)));
  return { liter: round(liter), kosten: round(kosten), proPerson: round(kosten / p) };
}

// --- Maßstab (faktor = X in 1:X) ---
export function massstab(faktor, wert, richtung = "realZuModell") {
  const f = num(faktor), w = num(wert);
  if (f <= 0) return 0;
  return richtung === "modellZuReal" ? round(w * f) : round(w / f);
}
